import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppRoutesName } from '../../const/AppRoutesName';

export const routes: Routes = [
  {
    path: ':shop_uuid/' + AppRoutesName.EN.SUBMISSIONS,
    loadComponent: () =>
      import('./submissions.component').then((m) => m.SubmissionsComponent),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.SUBMISSIONS,
    loadComponent: () =>
      import('./submissions.component').then((m) => m.SubmissionsComponent),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.EN.SUBMISSIONS + '/:id',
    loadComponent: () =>
      import('../submission/submission.component').then(
        (m) => m.SubmissionComponent,
      ),
  },
  {
    path: ':shop_uuid/' + AppRoutesName.FR.SUBMISSIONS + '/:id',
    loadComponent: () =>
      import('../submission/submission.component').then(
        (m) => m.SubmissionComponent,
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SubmissionsModule {}
